import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import React, { useState, useEffect } from 'react';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "./table.css"
import InvitationStatus from '../Superadmin/InvitationStatus';
import { useFacultyStore } from '../../stores';
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import FacultyModal from './FacultyModal';
import withReactContent from "sweetalert2-react-content";
import { handleXhrError } from '../../utils';
const toastOptions = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};
const MySwal = withReactContent(Swal);
const sortCaretEle = (order, column) => {
  const Up = () => <span style={{ content: '', borderBottom: 0, borderTop: "4px dashed" }} className='caret'></span>
  const Down = () => <span style={{ content: '', borderTop: 0, borderBottom: "4px dashed" }} className='caret'></span>
  if (!order) return (<span>&nbsp;&nbsp;<Up />&ensp;<Down /></span>);
  else if (order === 'asc') return (<span>&nbsp;&nbsp;<Down /></span>);
  else if (order === 'desc') return (<span>&nbsp;&nbsp;<Up /></span>);
  return null;
}
const headerSortingStyle = { backgroundColor: '#c8e6c9' };
const BranchesTable = (props) => {
  const addAllFaculties = useFacultyStore((state) => state.addAllFaculties)
  const faculties = useFacultyStore((state) => state.faculties);
  const addFaculty = useFacultyStore((state) => state.addFaculty);
  const OnUpdateFaculty = (data) => {
    window.$.ajax({
      type: "put",
      url: "/api/coo/faculty/" + data._id + "?faculty=" + data.facultyId,
      xhrFields: {
        withCredentials: true,
      },
      data: {
        firstName: data.faculty.firstName,
        email: data.faculty.email
      },
      dataType: "json",
      success: (response, textStatus, request) => {
        console.log(response);
        console.log("success")
        addFaculty(response.subject);
        MySwal.fire("Faculty successfully updated");
        setOpenModal(false);

      },
      statusCode: {

        404: function () {
          // e.target.disabled = false;
          toast.error("page not found", toastOptions);
        },
        400: function (res) {
          // e.target.disabled = false;
          if (!res.responseJSON) {
            toast.error("Something went wrong...", toastOptions);
            return;
          }

          toast.error(res.responseJSON.message, toastOptions);
          return;
        },
      },
      headers: {
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "",
      },
      error: function (res, textStatus, err) {
        handleXhrError(res, textStatus, err, () => {
          // e.target.disabled = false;
        })
      },
    });

  }
  useEffect(() => {
    window.$.ajax({
      type: "get",
      url: "/api/coo/faculties",
      xhrFields: {
        withCredentials: true,
      },
      dataType: "json",
      success: (response, textStatus, request) => {
        console.log(response);
        addAllFaculties(response.subjects);

      },
      statusCode: {

        404: function () {

          toast.error("page not found", toastOptions);
        },
        400: function (res) {
          if (!res.responseJSON) {
            toast.error("Something went wrong...", toastOptions);
            return;
          }

          toast.error(res.responseJSON.message, toastOptions);
          return;
        },
      },
      headers: {
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "",
      },
      error: function (res, textStatus, err) {
        handleXhrError(res, textStatus, err, () => {
          // e.target.disabled = false;
        })
      },
    });
  }, []);
  const [openModal, setOpenModal] = useState(false);
  const [editableRow, setEditableRow] = useState({ faculty: {} });
  const options = {
    // pageStartIndex: 0,
    sizePerPage: 5,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true
  };
  const columns = [
    {
      dataField: 'name',
      text: 'Subject',
      sort: true,
      Cell: row => (
        <div>
          <span style={{ color: "red" }} title={row.value}>{row.value}</span>
        </div>
      ),
      sortCaret: sortCaretEle,
      headerSortingStyle: headerSortingStyle,

    },
    {
      dataField: 'faculty.firstName',
      text: 'Lecturer name',
      sort: true,
      sortCaret: sortCaretEle,
      headerSortingStyle: headerSortingStyle,

      formatter: (content, row, rowIndex, formatExtraData) => {
        return <span style={{ color: "red" }} title={content}>{content}</span>
      }
    },
    {
      dataField: 'faculty.email',
      text: 'Lecturer email',
      sortCaret: sortCaretEle,
      headerSortingStyle: headerSortingStyle,

    },
    {
      dataField: 'invitation',
      text: 'Invitation',

      formatter: (content, row, rowIndex, formatExtraData) => {
        return (
          <InvitationStatus status={row.faculty.isVerified ? 'accepted' : 'invited'} />
        )

      }
    },
    {
      dataField: 'edit',
      text: ' ',
      formatter: (content, row, rowIndex, formatExtraData) => {
        return (
          <button className='btn btn-primary' onClick={(e) => { setEditableRow(row); setOpenModal(true); e.preventDefault(); }}>Edit</button>
        )
      }
    }
  ];
  return (
    <>
      <FacultyModal show={openModal} row={editableRow} onClose={() => setOpenModal(false)} OnUpdateFaculty={OnUpdateFaculty} />
      {/* {openModal?"true":"false"} */}
      <BootstrapTable
        keyField="id"
        data={faculties}
        columns={columns}
        pagination={paginationFactory(options)}
        striped
        hover
        condensed
        bordered={false}
      />
    </>
  );
}
export default BranchesTable;